import { useEffect } from 'react';
// import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
// import { Cookies } from 'react-cookie';
import { setAgentRequestConfig } from 'ui-common/src/utils/LoginActions';

// const checkOmniflowFeatureFlag = async () => {
//   try {
//     const cookies = new Cookies();
//     const token = cookies.get('access_token');
//     const tokenType = cookies.get('token_type');

//     const response = await fetch(
//       '/ECMv6/api/ispm/v1/config?moduleName=omniflow&key=OMNIFLOW_ENABLED',
//       {
//         method: 'GET',
//         headers: {
//           'Content-Type': 'application/json',
//           ...(token ? { Authorization: `${tokenType || 'Bearer'} ${token}` } : {}),
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error(`HTTP ${response.status}`);
//     }

//     const data = await response.json();
//     return data?.data?.value === 'true';
//   } catch (error) {
//     throw error;
//   }
// };

/**
 * Fetches OMNIFLOW_ENABLED from the config API and caches it via React Query.
 * SET_AGENT_REQUEST_CONFIG (appends without replacing existing domainInfo keys).
 */
const useOmniflowFeatureFlag = () => {
  const dispatch = useDispatch();
  // Disabled for now, as the feature flag is not being used in the app yet. Uncomment when needed.
  // const { ISPM_SERVICES_ENABLED } = useSelector((state) => state.user.domainInfo || {});

  // const { data: isOmniflowEnabled } = useQuery({
  //   queryKey: ['omniflow-feature-flag'],
  //   queryFn: checkOmniflowFeatureFlag,
  //   enabled: true,
  //   staleTime: 5 * 60 * 1000,
  //   cacheTime: 10 * 60 * 1000,
  //   retry: 3,
  //   retryDelay: (attemptIndex) => Math.min(1000 * Math.pow(2, attemptIndex), 5000),
  // });

  // useEffect(() => {
  //   dispatch(
  //     setAgentRequestConfig({ OMNIFLOW_ENABLED: ISPM_SERVICES_ENABLED ? isOmniflowEnabled : false })
  //   );
  // }, [isOmniflowEnabled, ISPM_SERVICES_ENABLED, dispatch]);

  useEffect(() => {
    dispatch(setAgentRequestConfig({ OMNIFLOW_ENABLED: false }));
  }, [dispatch]);
};

export default useOmniflowFeatureFlag;
